<template>
  <vue-custom-scrollbar class="scroll_wrap">
    <v-row
      class="ma-0 px-6 px-md-15 py-5 bg-gray"
      align="center"
      justify="space-between"
    >
      <v-col cols="auto" class="pa-0">
        <v-row class="ma-0" align="center">
          <v-col cols="auto" class="pa-0 mr-5">
            <v-img src="~@/img/main_img_com.png"></v-img>
          </v-col>
          <v-col cols="auto" class="pa-0">
            <span class="tab-title mr-4">{{ $t('나의 지원현황') }}</span>
            <span class="count">{{ applyList.length + saveList.length }}</span>
            <span class="unit">&nbsp;{{ $t('건') }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="auto" class="pa-0 ml-auto">
        <i-btn class="btn-type-05" @click="goAnnouncementPage">{{
          $t('채용공고 가기')
        }}</i-btn>
      </v-col>
    </v-row>
    <v-row
      class="mx-0 mx-md-15 mt-4 mt-md-8 mb-0"
      v-if="saveList && saveList.length > 0"
    >
      <v-col class="pa-0">
        <v-row
          class="ma-0 px-6 py-4 bg-gray bd-B-2px"
          align="center"
          justify="space-between"
        >
          <v-col cols="auto" class="pa-0 head-title">{{ $t('미제출') }}</v-col>
          <v-col cols="auto" class="pa-0">
            {{ $t('미제출지원서') }}
            <a class="submit-count">{{ saveList.length }}</a
            >{{ $t('건') }}
          </v-col>
        </v-row>
        <!-- only PC -->
        <v-row
          v-for="(item, idx) in saveList"
          class="ma-0 py-5 px-6 bd-B-1px d-none d-md-flex"
          align="center"
          justify="space-between"
          :key="'save' + idx"
        >
          <v-col
            cols="auto"
            class="pa-0 mr-4 icon-deadline"
            :class="{ 'is-closed': item.status === 'FIN' }"
          >
            <template v-if="item.status != 'FIN'">{{ $t('모집중') }}</template>
            <template v-else>{{ $t('마감') }}</template>
          </v-col>
          <v-col cols="" class="pa-0 list-title">{{ item.title }}</v-col>
          <v-col cols="auto" class="pa-0 ml-10 date-created"
            >{{ $t('작성일') }} {{ item.updateDate }}</v-col
          >
          <v-col cols="auto" class="pa-0">
            <i-btn
              class="ml-8 btn-type-03"
              @click="deleteApplyConfirm(item.applNo, item.recruitId)"
              >삭제</i-btn
            >
            <i-btn
              class="ml-2 btn-type-04"
              @click="goResumePage(item.recruitId)"
              >수정</i-btn
            >
          </v-col>
        </v-row>
        <!-- only mobile & tablet -->
        <v-row
          v-for="(item, idx) in saveList"
          class="ma-0 px-6 py-5 bd-B-1px d-sm-block d-md-none"
          align="center"
          justify="space-between"
          :key="'savem' + idx"
        >
          <v-row class="px-3 px-md-0 py-3 py-md-0">
            <v-col
              cols="auto"
              class="pa-0 mr-4 icon-deadline"
              :class="{ 'is-closed': item.status === 'FIN' }"
            >
              <template v-if="item.status != 'FIN'">{{
                $t('모집중')
              }}</template>
              <template v-else>{{ $t('마감') }}</template>
            </v-col>
            <v-col>
              <v-row cols="" class="pa-0 list-title">{{ item.title }}</v-row>
              <v-row cols="auto" class="pa-0 date-created"
                >{{ $t('작성일') }} {{ item.updateDate }}</v-row
              >
              <v-row cols="auto" class="pa-0 pt-3">
                <i-btn
                  class="btn-type-03 ml-auto"
                  @click="deleteApplyConfirm(item.applNo, item.recruitId)"
                  >삭제</i-btn
                >
                <i-btn
                  class="ml-2 btn-type-04"
                  @click="goResumePage(item.recruitId)"
                  >수정</i-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      class="mx-0 mx-md-15 mt-4 mt-md-8 mb-0 apply-list-wrap"
      v-if="applyList && applyList.length > 0"
    >
      <v-overlay
        absolute
        :value="applyListLoading"
        color="#ffffff"
        opacity="0.6"
      >
        <v-progress-circular
          indeterminate
          color="#087ef7"
        ></v-progress-circular>
      </v-overlay>
      <v-col class="pa-0">
        <v-row
          class="ma-0 px-6 py-4 bg-gray bd-B-2px"
          align="center"
          justify="space-between"
        >
          <v-col cols="auto" class="pa-0 head-title ">{{
            $t('제출완료')
          }}</v-col>
          <v-col cols="auto" class="pa-0">
            {{ $t('제출지원서') }}
            <a class="submit-count">{{ applyList.length }}</a
            >{{ $t('건') }}
          </v-col>
        </v-row>
        <apply-status-tabs
          class="mt-4"
          :tabs="tabs"
          :active-tab="activeTab"
          @change="onChangeActiveTab"
        ></apply-status-tabs>
        <!-- only PC -->
        <v-row
          v-for="(item, idx) in filteredApplyList"
          class="ma-0 px-6 py-5 bd-B-1px d-none d-md-flex"
          align="center"
          justify="space-between"
          :key="'apply' + idx"
        >
          <v-col
            cols="auto"
            class="pa-0 mr-4 icon-recruitment"
            :class="{ 'is-closed': item.status === 'FIN' }"
          >
            <template v-if="item.status != 'FIN'">{{ $t('모집중') }}</template>
            <template v-else>{{ $t('마감') }}</template>
          </v-col>
          <v-col cols="" class="pa-0 list-title col-true">
            {{ item.title }}
            <v-tooltip
              v-if="item.isPrivate"
              bottom
              content-class="private-tag-tooltip"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-on="on"
                  v-bind="attrs"
                  label
                  small
                  class="private-tag"
                  color="#f1f3f5"
                >
                  <span class="private-tag-dot">●</span>전형 상태 비공개
                </v-chip>
              </template>
              <span>{{
                $t('해당 공고는 전형 진행 상태가 지원자에게 공개되지 않습니다.')
              }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="auto" class="pa-0 ml-10 date-created"
            >{{ $t('작성일') }} {{ item.updateDate }}</v-col
          >
          <v-col cols="auto" class="pa-0">
            <i-btn
              v-if="item.imageNotice"
              class="ml-2 btn-type-04"
              @click="openUploadPhotoPopup(item.imageNotice, item.image)"
              >{{ $t('사진 등록') }}</i-btn
            >
            <i-btn
              v-if="item.cancelYn"
              class="ml-2 btn-type-04"
              @click="cancelApplyConfirm(item.applNo, item.recruitId)"
              >{{ $t('제출취소') }}</i-btn
            >
            <v-tooltip
              bottom
              v-if="!item.cancelYn && item.modifyBlockYn === 'Y'"
            >
              <template v-slot:activator="{ on, attrs }">
                <span class="ml-2 btn-block-msg" v-bind="attrs" v-on="on">
                  제출취소 불가
                </span>
              </template>
              <div>제출 후 제출취소 및 지원서 수정이 불가합니다.</div>
              <div>제출취소를 원하실 경우 관리자에게 문의해 주세요.</div>
            </v-tooltip>
            <i-btn
              class="ml-2 btn-type-03"
              @click="goResumePage(item.recruitId)"
              >{{ $t('지원서보기') }}</i-btn
            >
            <PopApplyResult
              v-if="item.resultMsg && item.finalYn !== 'Y'"
              :result="item.resultMsg"
            ></PopApplyResult>
          </v-col>
        </v-row>
        <!-- only mobile & tablet -->
        <v-row
          v-for="(item, idx) in filteredApplyList"
          class="ma-0 px-6 py-5 bd-B-1px d-sm-block d-md-none"
          align="center"
          justify="space-between"
          :key="'applym' + idx"
        >
          <v-row class="px-3 px-md-0 py-3 py-md-0">
            <v-col
              cols="auto"
              class="pa-0 mr-4 icon-recruitment"
              :class="{ 'is-closed': item.status === 'FIN' }"
            >
              <template v-if="item.status != 'FIN'">{{
                $t('모집중')
              }}</template>
              <template v-else>{{ $t('마감') }}</template>
            </v-col>
            <v-col>
              <v-row cols="" class="pa-0 list-title">
                {{ item.title }}
                <v-tooltip
                  v-if="item.isPrivate"
                  bottom
                  content-class="private-tag-tooltip"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      v-on="on"
                      v-bind="attrs"
                      label
                      small
                      class="private-tag"
                      color="#f1f3f5"
                    >
                      <span class="private-tag-dot">●</span>전형 상태 비공개
                    </v-chip>
                  </template>
                  <span>{{
                    $t(
                      '해당 공고는 전형 진행 상태가 지원자에게 공개되지 않습니다.',
                    )
                  }}</span>
                </v-tooltip>
              </v-row>
              <v-row cols="auto" class="pa-0 date-created"
                >{{ $t('작성일') }} {{ item.updateDate }}</v-row
              >
              <v-row cols="auto" class="pa-0 pt-3" justify="end">
                <i-btn
                  v-if="item.imageNotice"
                  class="ml-2 btn-type-04"
                  @click="openUploadPhotoPopup(item.imageNotice, item.image)"
                  >{{ $t('사진 등록') }}</i-btn
                >
                <i-btn
                  v-if="item.cancelYn"
                  class="ml-2 btn-type-04"
                  @click="cancelApplyConfirm(item.applNo, item.recruitId)"
                  >{{ $t('제출취소') }}</i-btn
                >
                <span
                  v-if="!item.cancelYn && item.modifyBlockYn === 'Y'"
                  class="ml-auto btn-block-msg"
                  @click="showModifyBlockInfo"
                >
                  제출취소 불가
                </span>
                <i-btn
                  class="ml-2 btn-type-03"
                  @click="goResumePage(item.recruitId)"
                  >지원서보기</i-btn
                >
                <PopApplyResult
                  v-if="item.resultMsg && item.finalYn !== 'Y'"
                  :result="item.resultMsg"
                ></PopApplyResult>
              </v-row>
            </v-col>
          </v-row>
        </v-row>
      </v-col>
    </v-row>
    <!-- 이미지 변경 팝업 -->
    <BasePopup
      width="500"
      v-model="uploadPhotoPopup.show"
      confirmButtonText="저장"
      :confirmCallback="saveProfileImage"
      useScrollbar
      title="사진 등록"
    >
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0 pt-3 d-flex justify-center">
          <v-avatar class="avatar-wrap" size="160">
            <v-icon
              size="48"
              v-if="!uploadPhotoPopup.src"
              color="#d8d8d8"
              class="material-icons-outlined mdi"
              >person</v-icon
            >
            <img v-else :src="uploadPhotoPopup.src" />
          </v-avatar>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0 d-flex justify-center mt-5">
          <i-btn
            class="mr-3"
            style="font-weight:600"
            outlined
            :disabled="!uploadPhotoPopup.src"
            @click="
              () => {
                uploadPhotoPopup.src = '';
                $refs.file.value = '';
              }
            "
          >
            {{ $t('사진삭제') }}
          </i-btn>
          <i-btn
            outlined
            color="primary"
            style="font-weight:600"
            @click="$refs.file.click()"
          >
            {{ $t('사진등록') }}
          </i-btn>
        </v-col>
      </v-row>
      <v-row class="my-0 mx-n8">
        <v-col cols="12" class="mt-8 pa-8 mb-n6 text-center info-wrap">
          <p class="info-desc" style="white-space: pre-wrap;">
            {{ uploadPhotoPopup.desc }}
          </p>
          <p class="mt-4 info-title d-flex align-center justify-center">
            <v-icon
              size="20"
              color="#000000"
              class="material-icons-outlined mdi"
              >date_range</v-icon
            ><span>{{ $t('등록기간') }}</span
            ><span class="ml-3 date point-blue">{{
              uploadPhotoPopup.date
            }}</span>
          </p>
        </v-col>
      </v-row>
    </BasePopup>
    <input
      v-show="false"
      type="file"
      ref="file"
      accept="image/*"
      @change="setPreview"
    />
  </vue-custom-scrollbar>
</template>

<script>
import moment from 'moment';
import { DialogMixin } from '@/mixin/dialog.js';
import { LoadingMixin } from '@/mixin/loading.js';
import PopApplyResult from '@/components/PopApplyResult.vue';
import ApplyStatusTabs from '@/components/MyApplyList/ApplyStatusTabs.vue';
import { getAuthJson, postAuthJson, postMultipart } from '@/api/network';

const reader = new FileReader();
const fileToBase64 = file =>
  new Promise((resolve, reject) => {
    reader.readAsDataURL(file);
    reader.onload = event => {
      resolve(event.target.result);
    };
    reader.onerror = error => {
      reject(error);
    };
  });
export default {
  mixins: [DialogMixin, LoadingMixin],
  components: { PopApplyResult, ApplyStatusTabs },
  mounted() {
    this.getApplyList();
  },
  data() {
    return {
      saveList: [],
      applyList: [],
      annoListUrl: '',
      activeTab: 'ALL',
      applyListLoading: false,
      uploadPhotoPopup: {
        show: false,
        src: null,
        date: '',
        desc: '',
        recruitId: '',
        fileId: '',
        fileLimitSize: null,
      },
    };
  },
  computed: {
    applyListWithTabCategory() {
      return this.applyList.map(item => ({
        ...item,
        tabCategory: this.resolveTabCategory(item),
        isPrivate: item.stepSyncYn !== 'Y',
      }));
    },
    tabs() {
      return [
        {
          key: 'ALL',
          label: '전체',
          count: this.applyListWithTabCategory.length,
        },
        { key: 'APPLY', label: '지원완료', count: this.countByTab('APPLY') },
        { key: 'PAPER', label: '서류전형', count: this.countByTab('PAPER') },
        {
          key: 'INTERVIEW',
          label: '면접전형',
          count: this.countByTab('INTERVIEW'),
        },
        {
          key: 'CONFIRM',
          label: '최종합격',
          count: this.countByTab('CONFIRM'),
        },
        { key: 'FAIL', label: '불합격', count: this.countByTab('FAIL') },
      ];
    },
    filteredApplyList() {
      if (this.activeTab === 'ALL') return this.applyListWithTabCategory;
      return this.applyListWithTabCategory.filter(
        item => item.tabCategory === this.activeTab,
      );
    },
  },
  methods: {
    onChangeActiveTab(tabKey) {
      this.activeTab = tabKey;
      this.applyListLoading = true;
      this.getApplyList().finally(() => {
        this.applyListLoading = false;
      });
    },
    resolveTabCategory(item) {
      if (item.stepSyncYn !== 'Y') return 'APPLY';
      if (item.stepPassYn === 'N') return 'FAIL';
      if (item.finalYn === 'Y') return 'CONFIRM';
      if (!item.stepType || item.stepType === 'APPLY') return 'APPLY';
      if (item.stepType.includes('PAPER')) return 'PAPER';
      if (item.stepType.includes('INTERVIEW')) return 'INTERVIEW';
      if (item.stepType === 'CONFIRM') return 'CONFIRM';
      return 'APPLY';
    },
    countByTab(category) {
      return this.applyListWithTabCategory.filter(
        item => item.tabCategory === category,
      ).length;
    },
    async deleteApplyConfirm(applNo, annoId) {
      const p = { applNo: applNo, annoId: annoId };
      const answer = await this.$confirm('지원서를 삭제하시겠습니까?');
      answer && this.deleteApply(p);
    },
    deleteApply: function(param) {
      postAuthJson(
        'api/v1/' + this.$route.params.tenantKey + '/delete/apply',
        param,
      )
        .then(res => {
          this.hideLoading();
          if (res.status === 200) {
            this.$showAlert({
              message: '삭제되었습니다.',
              callback: this.getApplyList,
            });
          }
        })
        .catch(error => {
          console.log(error.response);
        });
    },
    async cancelApplyConfirm(applNo, annoId) {
      const p = { applNo: applNo, annoId: annoId };
      const answer = await this.$confirm('지원서 제출을 취소하시겠습니까?');
      answer && this.cancelApply(p);
    },
    showModifyBlockInfo() {
      this.$showAlert({
        title: '제출취소 불가 안내',
        message:
          '제출 후 제출취소 및 지원서 수정이 불가합니다. 제출취소를 원하실 경우 관리자에게 문의해 주세요.',
      });
    },
    cancelApply: function(param) {
      this.showLoading();
      postAuthJson(
        'api/v1/' + this.$route.params.tenantKey + '/cancel/applied',
        param,
      )
        .then(res => {
          this.hideLoading();
          if (res.data?.status === 'FAIL') {
            const message =
              res.data.message || '취소 처리 중 오류가 발생하였습니다.';
            this.$showAlert({ message, title: '', callback: null });
          } else {
            this.$showAlert({
              message: '취소되었습니다.',
              callback: this.getApplyList,
            });
          }
        })
        .catch(error => {
          this.hideLoading();
          console.log(error.response);
        });
    },
    goAnnouncementPage: function() {
      window.open(this.annoListUrl, '_blank');
    },
    goResumePage(annoId) {
      this.$router.push({
        name: 'cv',
        params: { annoId: annoId, tenantKey: this.$route.params.tenantKey },
      });
    },
    getApplyList: function() {
      return getAuthJson(
        'api/v1/' + this.$route.params.tenantKey + '/apply/list',
        {},
      ).then(res => {
        if (res.status == 200) {
          this.saveList = res.data.saveList;
          this.applyList = res.data.applyList;
          this.annoListUrl = res.data.annoListUrl;
        }
      });
    },
    // 사진등록 => 사진 업로드 프리뷰
    async setPreview(event) {
      if (!event.target.files) return;
      /** @type {File} */
      const file = event.target.files[0];
      if (file.type.split('/')[0] != 'image')
        return this.$showAlert(`이미지 파일만 가능합니다.`);
      if (file.size > this.uploadPhotoPopup.fileLimitSize * 1024 * 1024)
        return this.$showAlert(
          this.$t('파일 최대 크기는') +
            `${this.uploadPhotoPopup.fileLimitSize}` +
            this.$t('mb 입니다.'),
        );
      this.uploadPhotoPopup.src = await fileToBase64(file);
    },
    // 사진등록 => 사진 저장
    async saveProfileImage(close) {
      const file = this.$refs.file.files?.[0];
      try {
        if (
          (!this.uploadPhotoPopup.src && !this.uploadPhotoPopup.fileId) ||
          (!file && this.uploadPhotoPopup.src)
        )
          return close();
        this.showLoading();
        if (!this.uploadPhotoPopup.src) {
          await postAuthJson(
            'api/v1/' +
              this.$route.params.tenantKey +
              '/cv/file/' +
              this.uploadPhotoPopup.fileId,
            {
              annoId: this.uploadPhotoPopup.recruitId,
            },
          );
          this.$showAlert(`저장 되었습니다.`);

          this.hideLoading();
        } else if (file) {
          this.showLoading();
          const tenantKey = this.$route.params.tenantKey;
          const formData = new FormData();
          formData.append('annoId', this.uploadPhotoPopup.recruitId);
          formData.append('file', file, file.name);
          formData.append('existingFileId', this.uploadPhotoPopup.fileId || '');

          const {
            data: { fileId },
          } = await postMultipart(
            'api/v1/' + tenantKey + '/cv/image',
            formData,
          );
          await postAuthJson('api/v1/' + tenantKey + '/user/image', {
            annoId: this.uploadPhotoPopup.recruitId,
            fileId,
          });
          this.hideLoading();
          this.$showAlert(`저장되었습니다.`);
          this.uploadPhotoPopup.show = false;
        }
      } catch (error) {
        console.error(error);
        this.hideLoading();
        this.$showAlert(
          '파일이 정상적으로 업로드 되지 않았습니다.\n다시 한 번 업로드 하시기 바랍니다.',
        );
      }
      close();
      this.getApplyList();
    },
    // 사진등록 => 사진등록 팝업 오픈
    async openUploadPhotoPopup(item, fileId) {
      this.showLoading();

      let src = '';
      this.$refs.file.value = '';
      if (fileId) {
        try {
          const { data } = await getAuthJson(
            'api/v1/' +
              this.$route.params.tenantKey +
              '/cv/file/image/' +
              fileId,
            {
              annoId: item.id.annoId,
            },
          );
          src = data;
        } catch (error) {
          console.error(error);
          src = '';
        }
      }
      this.hideLoading();
      Object.assign(this.uploadPhotoPopup, {
        show: true,
        date: `${moment(item.startDate).format('YYYY-MM-DD')}~${moment(
          item.endDate,
        ).format('YYYY-MM-DD')}`,
        src,
        desc: item.notiDesc,
        fileId: fileId ?? '',
        recruitId: item.id.annoId,
        fileLimitSize: item.info.files[0].fileLimitSize,
        noticeId: item.id,
      });
    },
  },
};
</script>

<style>
.apply-list-wrap {
  position: relative;
}
.private-tag-tooltip {
  background-color: #f1f3f5 !important;
}
.private-tag {
  border-radius: 16px !important;
  margin-left: 8px;
}
.private-tag-dot {
  font-size: 8px;
  margin-right: 4px;
  vertical-align: middle;
}
.btn-block-msg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  vertical-align: middle;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #d8d8d8;
  border-radius: 6px;
  background-color: #f5f6f8;
  box-sizing: border-box;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.28px;
  line-height: 1;
  color: #9aa3b0;
  white-space: nowrap;
  cursor: default;
}
</style>
